import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoChartArrowDown, LazySvgoChartArrowUp, LazySvgoMicrophone, LazySvgoPhone } from '#components'
const lazyGlobalComponents = [
  ["SvgoChartArrowDown", LazySvgoChartArrowDown],
["SvgoChartArrowUp", LazySvgoChartArrowUp],
["SvgoMicrophone", LazySvgoMicrophone],
["SvgoPhone", LazySvgoPhone],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
